import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { FormProvider } from "react-hook-form";
import Select from "react-select";
import SelectCategoriaAtendimento from "../../../../Components/CardsPages/Forms/SelectCategoriaAtendimento";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarUsuariosController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { IFiltroAtendimentosVistorias } from "../../../../Interfaces/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasInterfaces";
import { ACESSOS } from "../../../../Routes/Acessos";
import StorageManagerCapys from "../../../../Tools/Storage";
import { TModoGestaoAtendimento } from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import useFiltroAtendimentoVistoria from "./useFiltroAtendimentoVistoria";
// import { Switch } from "../../../../Components/CardsPages/Forms/Switch";
// import Swal from "sweetalert2";

interface IFiltroAtendimemtoVistoriaProps {
    // listarUnidades(arg0: { ID_EMPREENDIMENTO: number[]; }): unknown;
    handleSubmit: (filter: IFiltroAtendimentosVistorias) => void;
    defaultFilter?: IFiltroAtendimentosVistorias;
    storageManager: StorageManagerCapys<IFiltroAtendimentosVistorias>;
    setIdEmpreendimentoOption: Dispatch<
        SetStateAction<{ label: string; value: number }[] | null>
    >;
    setIdUnidadeOption: Dispatch<
    SetStateAction<{ label: string; value: number }[] | null>
    >;
    idEmpreendimentoOption?:
        | {
              label: string;
              value: number;
          }[]
        | null;
    idUnidadeOption?:
        | {
              label: string;
              value: number;
          }[]
        | null;
    setValueEtapa: Dispatch<
        SetStateAction<
            | {
                  label: string;
                  value: number;
              }[]
            | null
        >
    >;
    valueEtapa?:
        | {
              label: string;
              value: number;
          }[]
        | null;

    setIdTipoPeso: Dispatch<SetStateAction<number[]>>;
    idTipoPeso: number[];
    atendimento: TModoGestaoAtendimento;

    // setNaoContem: Dispatch<SetStateAction<boolean>>;
}

export function FiltroAtendimentoVistoria(
    props: IFiltroAtendimemtoVistoriaProps
) {
    const {
        filter,
        FormMethods,
        reset,
        control,
        handleCriarFiltros,
        selectInputRef,
        selectEmpRef,
        etapaRef,
        tipoRef,
        limparFiltros,
        customStyles,
        listarCanalAtendimento,
        etapasOptions,
        lstEmpreendimentosOptions,
        lstTipoPesoOptions,
        filtroInicial,
        lstUnidadesOptions,
        listarUnidades
    } = useFiltroAtendimentoVistoria(props.handleSubmit, props.defaultFilter);

    return (
        <>
            <FormProvider {...FormMethods}>
                <StickyToolbar active={Boolean(filter)}>
                    <UnForm handleSubmit={handleCriarFiltros} usingContext>
                        <div className="col-12 mt-3">
                            <label>Status do Caso</label>
                            <UnForm.Select
                                className="form-control"
                                name="DS_STATUS_CASO"
                                defaultValue={
                                    filter?.DS_STATUS_CASO ?? "Aberto"
                                }
                            >
                                <option></option>
                                <option>Aberto</option>
                                <option>Fechado</option>
                                <option>Cancelado</option>
                            </UnForm.Select>
                        </div>
                        <div className="col-12 mt-3">
                            <label>Empreendimento</label>
                            <Select
                                name="ID_EMPREENDIMENTO"
                                ref={selectEmpRef}
                                options={lstEmpreendimentosOptions}
                                value={props.idEmpreendimentoOption}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    props.setIdEmpreendimentoOption(
                                        e.map((value) => ({
                                            label: value.label,
                                            value: value.value,
                                        }))
                                    );
                                    const ids = e.map((v)=> v.value)
                                    listarUnidades({
                                        ID_EMPREENDIMENTO: ids,
                                    });
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Sem opções"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Unidade</label>
                            <Select
                                name="ID_UNIDADE"
                                ref={selectInputRef}
                                options={lstUnidadesOptions}
                                value={props.idUnidadeOption}
                                isClearable
                                isMulti
                                onChange={(e) => {
                                    props.setIdUnidadeOption(
                                        e.map((value) => ({
                                            label: value.label,
                                            value: value.value,
                                        }))
                                    );
                                }}
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                placeholder={""}
                                noOptionsMessage={() => "Sem opções"}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Solicitação</label>
                            <UnForm.Input
                                className="form-control"
                                type="number"
                                name="ID_CASO"
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Cliente</label>
                            <UnForm.Input
                                className="form-control"
                                type="text"
                                name="DS_NOME_CONTA"
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Situação</label>
                            <UnForm.Select
                                className="form-control"
                                name="FL_ANDAMENTO"
                            >
                                <option value={2}>Todos</option>
                                <option value={1}>Em Atendimento</option>
                                <option value={0}>Fila de Atendimento</option>
                            </UnForm.Select>
                        </div>

                        {props.atendimento !== "USUARIO" && (
                            <div className="col-12 mt-3">
                                <label>Atendente</label>
                                <UnForm.LazySelect
                                    className="form-control"
                                    name="ID_USUARIO"
                                    controller={ListarUsuariosController}
                                    getDS={(u) => u.DS_NOME}
                                    getKeyValue={(u) => u.ID_USUARIO}
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                        )}

                        <div className="col-12 mt-3">
                            <label>Categoria de Atendimento</label>
                            <SelectCategoriaAtendimento
                                ID_MODULO={ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO}
                                className={`form-control placeholder-dark-75`}
                                control={control}
                                name="ID_CATEGORIA_ATENDIMENTO"
                                multiple
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Etapa</label>
                            <Select
                                name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                placeholder={""}
                                menuPlacement="auto"
                                noOptionsMessage={() => "Nenhuma opção"}
                                styles={customStyles}
                                options={etapasOptions}
                                value={props.valueEtapa}
                                ref={etapaRef}
                                onChange={(e) =>
                                    props.setValueEtapa(
                                        e as SetStateAction<
                                            | {
                                                  label: string;
                                                  value: number;
                                              }[]
                                            | null
                                        >
                                    )
                                }
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                isClearable
                                isMulti
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Peso Atendimento</label>
                            <Select
                                placeholder={""}
                                menuPlacement="auto"
                                ref={tipoRef}
                                onChange={(e) =>
                                    props.setIdTipoPeso(
                                        e.map((value) => value?.value)
                                    )
                                }
                                components={{
                                    DropdownIndicator: () => null,
                                    IndicatorSeparator: () => null,
                                }}
                                styles={customStyles}
                                options={lstTipoPesoOptions}
                                noOptionsMessage={() => "Nenhuma opção"}
                                isClearable
                                isMulti
                            />
                        </div>
                        <div className={`col-12 mt-3 `}>
                            <UnForm.LazySelect
                                wrapperClassName="p-2 col-12 mb-3"
                                {...FormMethods}
                                defaultValue={filter?.ID_TIPO_CANAL_ATENDIMENTO}
                                className="mb-4"
                                label="Canal de Atendimento"
                                name="ID_TIPO_CANAL_ATENDIMENTO"
                                controller={listarCanalAtendimento}
                                getKeyValue={(u) => u.ID_TIPO_CANAL_ATENDIMENTO}
                                getDS={(u) => u.DS_TIPO_CANAL_ATENDIMENTO}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        {/* <div className={`col-12 mt-3 `}>
                            <label>Não contém</label>
                            <div className="d-flex justify-content-start">
                                <Switch
                                    color="success"
                                    labelPosition="top"
                                    type="checkbox"
                                    name="FL_CONTEM"
                                    onChange={(e) => {
                                        if (e.target.checked === true) {
                                            Swal.fire({
                                                title: "Ao ativar a opção 'Não Contém', sua pesquisa retornará todos os registros que não têm o texto especificado.",
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Ok!",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                },
                                            });
                                            props.setNaoContem(false);
                                        } else {
                                            props.setNaoContem(true);
                                        }
                                    }}
                                    defaultChecked={false}
                                />
                            </div>
                        </div> */}
                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    props.storageManager.remove();
                                    reset(filtroInicial);
                                    limparFiltros();
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </StickyToolbar>
            </FormProvider>
        </>
    );
}
